(function () {
  class SymbolAnimator extends PIXI.Container {
    constructor() {
      super();
      this._movies = []; // currently playing movies
      this._movieData = {};
      this._completeCb = undefined;
      this.coinData;
      this._isPlaying = false;
    }

    // for each symbol we store a pool for this type and also its type so it can be instantiated when pool is empty
    initialiseMoviePool(symbolMovies) {
      for (let prop in symbolMovies) {
        if (symbolMovies.hasOwnProperty(prop)) {
          let data = symbolMovies[prop];
          this._movieData[prop] = {
            pool: {},
            type: data.type,
            numInstantiated: 0,
            playData: data.playData,
          };
        }
      }
    }

    // get a movie file from the pool of movies. Reserved space is how much cells the symbol takes up, think gigablox and megaways
    getSymbolAnimation(symbolId, reservedSpace, slotCell) {
      let movie = undefined;

      let data = this._movieData["" + symbolId];
      // are there any movies in the pool we can use?

      const poolKey = String(reservedSpace);
      const isWolfOrPowerPack =
        symbolId === gameData.symbols["Wolf_Oversize"].ID ||
        symbolId === gameData.symbols["Symbol_Power_Pack_Oversized"].ID;

      const isOversized = data?.type === "oversizedSymbolAnimator";

      if (data.pool[poolKey]?.length > 0) {
        if (isWolfOrPowerPack || isOversized) {
          const pool = this._movieData[symbolId].pool[poolKey];

          for (const item of pool) {
            resourceManager.destroyObject(item.Props.FQN);
          }

          this._movieData[symbolId].pool = {};

          movie = resourceManager.createObject(
            data.type,
            `symbolAnim_${symbolId}_${slotCell}_${data.numInstantiated}`,
            this.name,
            { playData: data.playData }
          );

          data.numInstantiated++;
        } else {
          movie = data.pool[poolKey].pop();
        }
      } else {
        // No movies left in pool, create a new one
        movie = resourceManager.createObject(
          data.type,
          `symbolAnim_${symbolId}_${slotCell}_${data.numInstantiated}`,
          this.name,
          { playData: data.playData }
        );
        data.numInstantiated++;
      }

      // if powerpack pulse movie, need to move it so that it doesn't underlap the static award display asset, then move back after pulsed
      if (symbolId === 19) {
        const animatorContainer = resourceManager.get(
          "slotContainer:BonusLandAnimator"
        );
        const ppStaticContainer = resourceManager.get(
          "slotContainer:powerPackAwardDisplay"
        );
        const ppStatic = resourceManager.get(
          `slotContainer:powerPackAwardDisplay:powerPackTotalMovie${slotCell}`
        );
        const ppStaticIndex = ppStaticContainer.getChildIndex(ppStatic);
        ppStaticContainer.addChildAt(movie, ppStaticIndex);
        movie.extraCB = () => {
          animatorContainer.addChild(movie);
        };
      }
      return movie;
    }

    onSymbolTracked(loop, onCellAnimFinishedCb, trackInfo, isOversized) {
      let slotCell =
        trackInfo.cell.reel * gameData.numRows + trackInfo.cell.row;
      if (this.coinData) {
        trackInfo.coinData = this.coinData;
        trackInfo.inCashlinkStart = this.cashlinkStart;
      }
      if (this.moonData) {
        trackInfo.moonData = this.moonData;
      }
      if (gameController.inCashLink) {
        slotCell = trackInfo.cell.reel;
      }
      let movie = this.getSymbolAnimation(
        trackInfo.symbolId,
        trackInfo.reservedSpace,
        slotCell,
        isOversized
      );

      let callBack = onCellAnimFinishedCb;
      if (movie.extraCB != null) {
        callBack = (who) => {
          movie.extraCB();
          onCellAnimFinishedCb(who);
        };
      }
      movie.play(trackInfo, loop, callBack);
      this._movies.push(movie);
    }

    invokeCompleteCallback() {
      if (this._completeCb) {
        this._isPlaying = false;
        let cb = this._completeCb;
        this._completeCb = undefined;
        cb();
      }
    }

    onSymbolUntracked(trackInfo) {
      for (let i = 0; i < this._movies.length; ++i) {
        let movie = this._movies[i];
        let movieTrackInfo = movie.getTrackInfo();
        if (
          movieTrackInfo.uniqueSymbolId === trackInfo.uniqueSymbolId &&
          movieTrackInfo.reelId === trackInfo.reelId
        ) {
          let data = this._movieData[movieTrackInfo.symbolId];
          if (data.pool["" + trackInfo.reservedSpace] === undefined)
            data.pool["" + trackInfo.reservedSpace] = [];

          data.pool["" + trackInfo.reservedSpace].push(movie);
          this._movies.splice(i, 1);
          movie.finalise();
          break;
        }
      }

      if (this._movies.length === 0) {
        // All animations complete, so call complete callback
        this.invokeCompleteCallback();
      }
    }

    skip() {
      while (this._movies.length > 0) {
        // dont replace with for loop as skipping removes elements from the movies array so it will skip elements as its size changes.
        this._movies[0].skip();
      }
      this.invokeCompleteCallback();
    }

    trackAllWinningSymbols(symbols, slotMachine, loop, isOversized) {
      let onCellAnimFinishedCb = function (who) {
        who.untrack();
      };
      for (let i = 0; i < symbols.length; ++i) {
        let data = symbols[i];
        slotMachine.trackSymbolInWindow(
          data.cell.reel,
          data.cell.row,
          data.symbolId,
          this.onSymbolTracked.bind(this, loop, onCellAnimFinishedCb),
          this.onSymbolUntracked.bind(this)
        );
      }
    }

    isPlaying() {
      return this._isPlaying;
    }

    animateSymbols(
      symbols,
      slotMachine,
      canCelebrate,
      loop,
      callback,
      coinData,
      moonData,
      cashlinkStart,
      isOversized
    ) {
      // Handle optional data assignments
      this._isPlaying = true;

      if (coinData) {
        this.coinData = coinData;
        this.cashlinkStart = cashlinkStart;
      }

      if (moonData) {
        this.moonData = moonData;
      }

      // Handle celebration logic
      if (canCelebrate) {
        this._completeCb = callback;
        if (isOversized) {
          this.untrackOversized(symbols);
        }
        this.trackAllWinningSymbols(symbols, slotMachine, loop, isOversized);
      } else {
        callback?.(); // Safe callback execution
      }
    }

    //If we want to remove the oversized symbols from reels
    untrackOversized(symbols) {
      const { overSizedGroup, slotMachine } = gameController;

      symbols.forEach(({ symbolId, cell }) => {
        if (!overSizedGroup.includes(symbolId)) return;

        const reelSymbols = slotMachine.reels[cell.reel].getSymbolData();
        const uniqueId = reelSymbols[cell.row].uniqueId;

        if (slotMachine.isSymbolBeingTracked(cell.reel, uniqueId)) {
          slotMachine.removeSymbolTracker(cell.reel, uniqueId);
        }
      });
    }
  }

  let create = function () {
    return new SymbolAnimator();
  };

  let initialise = function (json, instance) {
    instance.initialiseMoviePool(json.symbolMovies);
  };

  let getRequiredFiles = function (json) {
    let allFiles = [];
    let keys = Object.keys(json.symbolMovies);
    let foundKeys = {};
    let indexes = [];
    for (let i = 0; i < keys.length; ++i) {
      let type = json.symbolMovies[keys[i]].type;
      if (foundKeys[type] === undefined) {
        foundKeys[type] = true;
        if (resourceManager.filesRequiredFunctions[type]) {
          let files = resourceManager.filesRequiredFunctions[type]();
          if (Array.isArray(files)) {
            allFiles = allFiles.concat(files);
          }
        }
      }
    }
    return allFiles;
  };

  resourceManager.registerObjectType(
    "SymbolAnimatorPP",
    create,
    initialise,
    getRequiredFiles
  );
})();
